import { useMemo, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { AuthProvider } from '@/auth/AuthProvider';
import type { AuthAdapter } from '@/auth/types';
import { TenantProvider } from '@/tenant/TenantProvider';
import { createQueryClient } from '@/lib/query';
import { Toaster, TooltipProvider } from '@/ui';
import { ThemeProvider } from './theme';
import { routes } from './routes';

export function App({ authAdapter }: { authAdapter: AuthAdapter }) {
  const [queryClient] = useState(createQueryClient);
  const router = useMemo(() => createBrowserRouter(routes), []);
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider adapter={authAdapter}>
          <TenantProvider>
            <TooltipProvider delayDuration={350} skipDelayDuration={150}>
              <RouterProvider router={router} />
              <Toaster />
            </TooltipProvider>
          </TenantProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
